import AppDBStorage from '@Services/AppDBStorage';

class ResultsPreviewStorage extends AppDBStorage {
  constructor() {
    super('previewResults_');
  }

  getDefaultValue = () => ({ previewResults: [], allResults: [] });
}

export default new ResultsPreviewStorage();
